(() => {
  if (window.HCStickyATCLoaded) return;
  window.HCStickyATCLoaded = true;

  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const selectors = {
    addButton: [
      'product-form button[name="add"]',
      'button.product-form__submit[name="add"]',
      'form[action*="/cart/add"] button[type="submit"]',
      'form[action*="/cart/add"] button[name="add"]'
    ],
    qtyInput: [
      'quantity-input input[name="quantity"]',
      'input.quantity__input[name="quantity"]',
      'form[action*="/cart/add"] input[name="quantity"]'
    ]
  };

  const cleanText = (text) => (text || '').replace(/\s+/g, ' ').trim();

  const toNumber = (value, fallback = 1) => {
    const parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const isInsideSticky = (el) => !!el?.closest?.('[data-hc-sticky-atc]');

  const findFirstOutsideSticky = (selectorList) => {
    for (const selector of selectorList) {
      const matches = Array.from(document.querySelectorAll(selector));
      const found = matches.find((el) => !isInsideSticky(el));
      if (found) return found;
    }
    return null;
  };

  const initStickyATC = (bar) => {
    if (bar.dataset.hcInitialized === 'true') return;
    bar.dataset.hcInitialized = 'true';

    const stickyBtn = bar.querySelector('[data-hc-sticky-button]');
    const stickyQty = bar.querySelector('[data-hc-qty-input]');
    const minusBtn = bar.querySelector('[data-hc-qty-minus]');
    const plusBtn = bar.querySelector('[data-hc-qty-plus]');
    const stickyError = bar.querySelector('[data-hc-sticky-error]');

    if (!stickyBtn || !stickyQty || !minusBtn || !plusBtn) return;

    let isSubmitting = false;
    let submitTimer = null;
    let fallbackTimer = null;
    let scrollTicking = false;

    const maxQtyMessage = 'The maximum quantity of this item is already in your cart.';

    const getRealButton = () => findFirstOutsideSticky(selectors.addButton);
    const getRealQty = () => findFirstOutsideSticky(selectors.qtyInput);

    const getRealErrorWrapper = () => {
      const wrappers = Array.from(
        document.querySelectorAll('.product-form__error-message-wrapper')
      );
      return wrappers.find((el) => !isInsideSticky(el)) || null;
    };

    const getRealErrorMessage = () => {
      const wrapper = getRealErrorWrapper();
      if (!wrapper) return '';

      const hidden =
        wrapper.hasAttribute('hidden') ||
        wrapper.getAttribute('aria-hidden') === 'true' ||
        wrapper.style.display === 'none';

      if (hidden) return '';

      const messageEl = wrapper.querySelector('.product-form__error-message');
      return cleanText(messageEl?.textContent || wrapper.textContent || '');
    };

    const showStickyError = (message) => {
      if (!stickyError) return;

      const text = cleanText(message);

      if (!text) {
        if (stickyError.textContent !== '') stickyError.textContent = '';
        if (!stickyError.hidden) stickyError.hidden = true;
        return;
      }

      if (stickyError.textContent !== text) stickyError.textContent = text;
      if (stickyError.hidden) stickyError.hidden = false;
    };

    const clearStickyError = () => {
      showStickyError('');
    };

    const syncRealErrorToSticky = (fallback = '') => {
      showStickyError(getRealErrorMessage() || fallback);
    };

    const getQtyRules = () => {
      const input = getRealQty();
      const min = Math.max(1, toNumber(input?.getAttribute('min'), 1));
      const maxRaw = input?.getAttribute('max');
      const max = maxRaw ? toNumber(maxRaw, Infinity) : Infinity;
      const step = Math.max(1, toNumber(input?.getAttribute('step'), 1));
      return { min, max, step };
    };

    const clampQty = (qty) => {
      const { min, max } = getQtyRules();
      let next = toNumber(qty, min);
      next = Math.max(min, next);
      if (Number.isFinite(max)) next = Math.min(max, next);
      return next;
    };

    const getCurrentQty = () => clampQty(stickyQty.value || 1);

    const getCurrency = () => bar.dataset.currency || 'USD';

    const formatMoneyFromCents = (cents) => {
      const amount = (Number(cents) || 0) / 100;
      const currency = getCurrency();

      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency
        }).format(amount);
      } catch (error) {
        return `$${amount.toFixed(2)}`;
      }
    };

    const getUnitPriceCents = () => {
      const cents = Number(bar.dataset.unitPriceCents);
      return Number.isFinite(cents) ? cents : 0;
    };

    const realButtonIsEnabled = () => {
      const button = getRealButton();
      if (!button) return false;

      const text = cleanText(button.textContent);
      const ariaDisabled = button.getAttribute('aria-disabled') === 'true';
      const loading =
        button.classList.contains('loading') ||
        button.getAttribute('aria-busy') === 'true' ||
        /adding|loading/i.test(text);

      return !button.disabled && !ariaDisabled && !loading;
    };

    const setAddButtonText = () => {
      const addText = bar.dataset.addText || 'Add to cart';
      const qty = getCurrentQty();
      const unitPriceCents = getUnitPriceCents();
      const totalText = formatMoneyFromCents(unitPriceCents * qty);
      const actionText = qty > 1 ? `Add ${qty} to cart` : addText;

      stickyBtn.textContent = `${actionText} · ${totalText}`;
    };

    const updateQtyButtons = () => {
      const { min, max } = getQtyRules();
      const value = clampQty(stickyQty.value);

      minusBtn.disabled = isSubmitting || value <= min;
      plusBtn.disabled = isSubmitting || (Number.isFinite(max) && value >= max);
      stickyQty.disabled = isSubmitting;
    };

    const updateButtonState = () => {
      const button = getRealButton();
      const realText = cleanText(button?.textContent);
      const soldOutText = bar.dataset.soldOutText || 'Sold out';

      if (isSubmitting) {
        stickyBtn.disabled = true;
        stickyBtn.textContent = 'Adding...';
        updateQtyButtons();
        return;
      }

      if (!button) {
        stickyBtn.disabled = true;
        setAddButtonText();
        updateQtyButtons();
        return;
      }

      const enabled = realButtonIsEnabled();
      stickyBtn.disabled = !enabled;

      if (!enabled && realText && !/add to cart/i.test(realText)) {
        stickyBtn.textContent = realText;
      } else if (!enabled) {
        stickyBtn.textContent = soldOutText;
      } else {
        setAddButtonText();
      }

      updateQtyButtons();
    };

    const setQty = (qty) => {
      const input = getRealQty();
      const next = clampQty(qty);

      stickyQty.value = next;

      if (input && input.value !== String(next)) {
        input.value = next;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      updateQtyButtons();
      if (!isSubmitting && realButtonIsEnabled()) setAddButtonText();
    };

    const syncFromRealQty = () => {
      const input = getRealQty();
      if (!input) return;

      stickyQty.value = clampQty(input.value || 1);
      updateQtyButtons();
      if (!isSubmitting && realButtonIsEnabled()) setAddButtonText();
    };

    const realButtonIsInView = () => {
      const button = getRealButton();
      if (!button) return false;

      const trigger =
        button.closest('.product-form') ||
        button.closest('product-form') ||
        button;

      if (!trigger) return false;

      const rect = trigger.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      return rect.bottom > 0 && rect.top < viewportHeight;
    };

    const updateVisibility = () => {
      const show =
        mobileQuery.matches &&
        window.scrollY > 220 &&
        !realButtonIsInView();

      bar.hidden = false;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('hc-sticky-atc-visible', show);
    };

    const requestVisibilityUpdate = () => {
      if (scrollTicking) return;

      scrollTicking = true;

      window.requestAnimationFrame(() => {
        scrollTicking = false;
        updateVisibility();
      });
    };

    const finishSubmitting = (fallbackMessage = '') => {
      window.clearTimeout(submitTimer);
      window.clearTimeout(fallbackTimer);

      isSubmitting = false;
      syncRealErrorToSticky(fallbackMessage);
      updateButtonState();
      updateQtyButtons();
      updateVisibility();
    };

    const scheduleSubmitUnlock = () => {
      window.clearTimeout(submitTimer);
      window.clearTimeout(fallbackTimer);

      submitTimer = window.setTimeout(() => {
        const realError = getRealErrorMessage();
        finishSubmitting(realError || '');
      }, 1600);

      fallbackTimer = window.setTimeout(() => {
        if (!isSubmitting) return;
        const realError = getRealErrorMessage();
        finishSubmitting(realError || maxQtyMessage);
      }, 3600);
    };

    const scrollToProductForm = () => {
      const button = getRealButton();
      const target = button?.closest('product-form') || button?.closest('form') || button;

      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    };

    minusBtn.addEventListener('click', () => {
      if (isSubmitting) return;
      clearStickyError();
      const { step } = getQtyRules();
      setQty(toNumber(stickyQty.value, 1) - step);
    });

    plusBtn.addEventListener('click', () => {
      if (isSubmitting) return;
      clearStickyError();
      const { step } = getQtyRules();
      setQty(toNumber(stickyQty.value, 1) + step);
    });

    stickyQty.addEventListener('input', () => {
      if (isSubmitting) return;
      clearStickyError();
      setAddButtonText();
    });

    stickyQty.addEventListener('change', () => {
      if (isSubmitting) return;
      clearStickyError();
      setQty(stickyQty.value);
    });

    stickyQty.addEventListener('blur', () => {
      if (isSubmitting) return;
      setQty(stickyQty.value);
    });

    stickyBtn.addEventListener('click', (event) => {
      event.preventDefault();

      if (isSubmitting) return;

      const button = getRealButton();

      if (!button || !realButtonIsEnabled()) {
        syncRealErrorToSticky();

        if (!getRealErrorMessage()) {
          scrollToProductForm();
        }

        return;
      }

      clearStickyError();
      isSubmitting = true;
      updateButtonState();
      setQty(stickyQty.value);

      window.requestAnimationFrame(() => {
        button.click();
        scheduleSubmitUnlock();
      });
    });

    const button = getRealButton();
    const input = getRealQty();
    const errorWrapper = getRealErrorWrapper();

    if (input) {
      syncFromRealQty();
      input.addEventListener('input', syncFromRealQty);
      input.addEventListener('change', syncFromRealQty);
    }

    if (button) {
      const buttonObserver = new MutationObserver(() => {
        const realError = getRealErrorMessage();

        if (realError && isSubmitting) {
          finishSubmitting(realError);
          return;
        }

        if (!isSubmitting) {
          updateButtonState();
          syncFromRealQty();
          syncRealErrorToSticky();
        }
      });

      buttonObserver.observe(button, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'class']
      });

      const trigger =
        button.closest('.product-form') ||
        button.closest('product-form') ||
        button;

      if ('IntersectionObserver' in window && trigger) {
        const io = new IntersectionObserver(updateVisibility, {
          threshold: 0.05
        });

        io.observe(trigger);
      }
    }

    if (errorWrapper) {
      const errorObserver = new MutationObserver(() => {
        const realError = getRealErrorMessage();

        if (realError && isSubmitting) {
          finishSubmitting(realError);
          return;
        }

        if (!isSubmitting) {
          syncRealErrorToSticky();
        }
      });

      errorObserver.observe(errorWrapper, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['hidden', 'aria-hidden', 'style', 'class']
      });
    }

    document.addEventListener('visibilitychange', updateVisibility);
    window.addEventListener('resize', updateVisibility, { passive: true });
    window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
    window.addEventListener('touchmove', requestVisibilityUpdate, { passive: true });
    window.addEventListener('touchend', requestVisibilityUpdate, { passive: true });

    window.setTimeout(updateVisibility, 300);
    window.setTimeout(updateVisibility, 900);

    updateButtonState();
    updateQtyButtons();
    syncRealErrorToSticky();
    updateVisibility();
  };

  const init = () => {
    document.querySelectorAll('[data-hc-sticky-atc]').forEach(initStickyATC);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();